import moment from 'moment';
import * as consts from '../constants/date';

/**
 * Check if the provided string is valid date
 *
 * @param {string} str
 *
 * @return {mixed}
 */
export const isDate = str => {
  if (str === 'Invalid date') {
    return false;
  }
  return str;
};

/**
 * Convert the provided date string to long dispaly format.
 *
 * @param {string} date
 *
 * @return {mixed}
 */
export const dateToDisplayFormat = date => {
  const dateObj = moment(date).format(consts.DATE_FORMAT_DISPLAY);
  return isDate(dateObj);
};

/**
 * Convert the provided date string to long dispaly format.
 *
 * @param {string} date
 * @param {string} fromFormat
 *
 * @return {mixed}
 */
export const dateToDisplayLongFormat = date => {
  const dateObj = moment(date).format(consts.DATE_FORMAT_DISPLAY_LONG);
  return isDate(dateObj);
};

/**
 * Convert the provided date string to UK dispaly format.
 *
 * @param {string} date
 * @param {string} format
 *
 * @return {mixed}
 */
export const dateToFormat = (date, format = consts.DATE_FORMAT_DISPLAY) => {
  const dateObj = moment(date).format(format);
  return isDate(dateObj);
};

/**
 * Convert the provided date string to `YYYY-MMM-DD` format.
 *
 * @param {string} date
 *
 * @return {mixed}
 */
export const dateToSqlFormat = date => {
  const dateObj = moment(date).format(consts.DATE_FORMAT_SQL);
  return isDate(dateObj);
};

/**
 * Convert the provided date string to display time format.
 *
 * @param {string} date
 * @param {string} fromFormat
 *
 * @return {mixed}
 */
export const dateToDisplayTimeFormat = date => {
  const dateObj = moment(date).format(consts.TIME_FORMAT_DISPLAY);
  return isDate(dateObj);
};

/**
 * Convert the provided date string to long dispaly date and time.
 *
 * @param {string} date
 * @param {string} fromFormat
 *
 * @return {mixed}
 */
export const dateTimeToDisplayLongFormat = (
  date,
  fromFormat = null,
  toFormat = consts.DATE_TIME_FORMAT_DISPLAY_LONG
) => {
  const dateObj = moment(date, fromFormat).format(toFormat);
  return isDate(dateObj);
};

/**
 * Converts UTC datetime to local formatted datetime.
 *
 * @param {string} date String in `YYYY-MM-DD HH:mm:ss` or ISO format.
 *
 * @return {string} datetime in `DD/MM/YYYY, hh:mm am|pm` format.
 */
export const formUtcToLocal = date => {
  if (!date) {
    return '';
  }
  const local = moment(date).local();
  return `${local.format('DD/MM/YYYY')} ${local.format('h:mma')}`;
};
